
import React from "react";
import Chapcha from '../Helper/Chapcha.js'

import Swal from 'sweetalert2'
import CheckVarizId from '../Helper/CheckVarizId.js'
import Loading from '../Helper/Loading.js'
import { apiCall } from '../Service/ConnectToServer.js';
import background from "../assets/img/index.png";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Col,
    FormGroup,
    Input, Row,
    Button,
    Modal,
    Alert
} from "reactstrap";

function Rules() {
    const [VarizValidate, setVarizValidate] = React.useState("");
    const [captcha1, setcaptcha1] = React.useState('');
    const [captchaEnter1, setcaptchaEnter1] = React.useState('');
    const [captchaRefresh1, setcaptchaRefresh1] = React.useState(false);

    const [captcha2, setcaptcha2] = React.useState('');
    const [captchaEnter2, setcaptchaEnter2] = React.useState('');
    const [captchaRefresh2, setcaptchaRefresh2] = React.useState(false);
    const [RefNum, setRefNum] = React.useState(0);
    const [VarizId, setVarizId] = React.useState(0);
    const [ModalOpen, setModalOpen] = React.useState(false);
    const [ModalHeaderColor, setModalHeaderColor] = React.useState("");
    const [PaymentReceipt, setPaymentReceipt] = React.useState({});
    const [TipsPage, setTipsPage] = React.useState([]);
    const [TipsLoading, setTipsLoading] = React.useState(true);

    const ValidClassName = (input) => {
        if (input === true) {
            return "is-valid"
        }
        else return "is-invalid"
    }

    const VarizChangeHandel = (target) => {
        if (target.validity.valid) {
            if (CheckVarizId(target.value)) {
                setVarizValidate(ValidClassName(true))
                setVarizId(target.value)
            }
            else {
                setVarizValidate(ValidClassName(false))
            }
        }
        else {
            setVarizValidate(ValidClassName(false))
        }
    }

    /*         React.useEffect(() => {
            console.log(match.params)
            }, []); 
     */
    const RefNumChangeHandel = (target) => {
        setRefNum(target.value);
    }

    const chapcha1HandelChange = (target) => {
        setcaptchaEnter1(target.value)
    }

    const chapcha2HandelChange = (target) => {
        setcaptchaEnter2(target.value)
    }


    const result1 = (text) => {
        setcaptcha1(text);
    }

    const result2 = (text) => {
        setcaptcha2(text);
    }

    const SubmitResNum = () => {
        document.querySelector(".button1").classList.toggle("button--loading");
        if (RefNum === 0) {
            Swal.fire({
                title: 'اطلاعات نادرست',
                text: 'شماره رهگیری را بدرستی وارد کنید',
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            document.querySelector(".button1").classList.toggle("button--loading");
        }
        else if (captcha1 !== captchaEnter1) {
            Swal.fire({
                title: 'اطلاعات نادرست',
                text: 'کد امنیتی را بدرستی وارد کنید',
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            document.querySelector(".button1").classList.toggle("button--loading");
        }
        else {
            const config = {
                method: "Post",
                url: "Payment/PayTrack",
                Authorization: true,
                data: {
                    RefNum: RefNum
                }
            }
            apiCall(config, (response) => {
                document.querySelector(".button1").classList.toggle("button--loading");
                setPaymentReceipt(response.data.Result);
                setModalOpen(true);
                setcaptchaRefresh1(!captchaRefresh1)
                if (response.data.Result.Status === 9) {
                    setModalHeaderColor("modalheadersuccess")
                }
                else {
                    setModalHeaderColor("modalheaderError")
                }
            }, (err) => {
                document.querySelector(".button1").classList.toggle("button--loading");
                Swal.fire({
                    title: 'عملیات ناموفق',
                    text: err,
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
            });
        }
   
    }

    const SubmitVarizId = () => {
        document.querySelector(".button").classList.toggle("button--loading");
        if (VarizValidate === "" || VarizValidate === "is-invalid") {
            Swal.fire({
                title: 'اطلاعات نادرست',
                text: 'شناسه واریز را بدرستی وارد کنید',
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            document.querySelector(".button").classList.toggle("button--loading");
        }
        else if (captcha2 !== captchaEnter2) {
            Swal.fire({
                title: 'اطلاعات نادرست',
                text: 'کد امنیتی را بدرستی وارد کنید',
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            document.querySelector(".button").classList.toggle("button--loading");
        }
        else {
            const config = {
                method: "Post",
                url: "Payment/PayTrack",
                Authorization: true,
                data: {
                    VarizId: VarizId
                }
            }
            apiCall(config, (response) => {
                document.querySelector(".button").classList.toggle("button--loading");
                setPaymentReceipt(response.data.Result);
                setModalOpen(true);
                setcaptchaRefresh2(!captchaRefresh2)
                if (response.data.Result.Status === 9) {
                    setModalHeaderColor("modalheadersuccess")
                }
                else {
                    setModalHeaderColor("modalheaderError")
                }
            }, (err) => {
                document.querySelector(".button").classList.toggle("button--loading");
                Swal.fire({
                    title: 'عملیات ناموفق',
                    text: err,
                    icon: 'error',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok'
                });
            });
        }
    }
    const ModalCloseHandel = () => {
        setModalOpen(false);
    }

    React.useEffect(() => {
        const Tipsconfig = {
            method: "Post",
            url: "User/GetUserTipsByPage",
            Authorization: true,
            data: { Page: 3 }
        }
        apiCall(Tipsconfig, (response) => {
            setTipsLoading(false);
            setTipsPage(response.data.Result);
        }, (err) => {
            console.log(err)
            Swal.fire({
                title: 'عملیات ناموفق',
                text: err,
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
        });
    }, []);


    return (
        <>
            <Modal className="modal-lg paymodal" isOpen={ModalOpen}  >
                <div className={"modal-header " + ModalHeaderColor} style={{
                    boxShadow: "rgb(152 182 187) 0px 5px 18px 0px",
                    textAlign: "center", display: "initial", paddingBottom: "25px"
                }}>
                    <strong className="modal-title" style={{ fontSize: "200%", color: "white" }}>
                        {ModalHeaderColor === "modalheaderError" ? "پرداخت ناموفق" : "پرداخت موفق"}
                    </strong>
                </div>

                <div className="modal-body">
                    <Col md="12">
                        <Col md="7" >
                            <Row>
                                <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                                    {/* <label> عنوان </label> */}
                                    <strong>{PaymentReceipt.TaxType}</strong>
                                </Col>
                            </Row>
                            <hr style={{ marginBottom: '2px' }} />

                            <Row>
                                <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                    <p> شناسه واریز </p>
                                    <strong>{PaymentReceipt.VarizId} </strong>
                                </Col>
                                <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                    <p>  شماره پیگیری </p>
                                    <strong>{PaymentReceipt.RefNum}</strong>
                                </Col>
                            </Row>
                            <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                            <Row>
                                <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                    <p>نام پرداخت کننده</p>
                                    <strong>{PaymentReceipt.PayerName}</strong>
                                </Col>
                                <Col className="pr-md-1" md="6" xs="6" style={{ textAlign: "center" }}>
                                    <p>  تاریخ </p>
                                    <strong>{PaymentReceipt.EmissionDate}</strong>
                                </Col>
                            </Row>
                            <hr style={{ marginTop: '2px', marginBottom: '2px' }} />
                            <Row>
                                <Col className="pr-md-1" md="12" xs="12" style={{ textAlign: "center" }}>
                                    <p> مبلغ پرداختی </p>
                                    <strong style={{ fontSize: '28px', color: 'green' }}>{PaymentReceipt.Amount}  </strong>
                                    <p>{PaymentReceipt.FaAmount}</p>
                                </Col>
                            </Row>
                        </Col>

                        <Col md="5">
                            <Card className="card-user">
                                <div>
                                    <div className="author">
                                        <div className="block block-one" />
                                        <div className="block block-two" />
                                        <div className="block block-three" />
                                        <div className="block block-four" />
                                        {PaymentReceipt.BankId === "1000" ?
                                            <img src={require("../assets/img/BankImage/meli.png").default} alt="..."
                                                className="avatar" />
                                            :
                                            <img src={require("../assets/img/BankImage/melat.png").default} alt="..."
                                                className="avatar" />}

                                        <p className="description">{PaymentReceipt.BankName}</p>
                                        <Row>
                                            <Col className="pr-md-1" md="6" xs="6">
                                                <p>شماره حساب </p>
                                                <strong>{PaymentReceipt.AccountNumber} </strong>
                                            </Col>
                                            <Col className="pr-md-1" md="6" xs="6">
                                                <p>صاحب حساب </p>
                                                <strong>{PaymentReceipt.AccountOwnerName}</strong>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                            </Card>
                        </Col>
                    </Col>
                </div>
                <div className="modal-footer"
                    style={{ boxShadow: "rgb(152 182 187) 0px 5px 18px 0px", paddingTop: "15px", paddingBottom: "15px" }}>
                    <hr />
                    <Col md="12">
                        <Button style={{ float: "left" }} outline color="info" onClick={() =>
                            ModalCloseHandel()
                        }>بستن</Button>
                    </Col>
                </div>
            </Modal>


            <div className="content text-right">
                <Card className="card-info">
                    <CardHeader>
                        <strong>استعلام و پیگیری پرداخت</strong>
                        <hr />
                    </CardHeader>
                    <CardBody>
                        <Alert style={{ textAlign: "center", backgroundColor: "slateblue" }}>
                            <span style={{ fontWeight: "bold", fontSize: "17px" }}>راهنما ! شما می توانید از طریق یکی از روش های زیر نسبت به پیگیری پرداخت خود اقدام نمائید. </span>
                        </Alert>
                        <Row>
                        <Col md="4"  sm="12" xs="12">
                            <Card className="card-info">
                                <CardHeader style={{ textAlign: "center" }}>
                                    <strong >روش اول: استعلام از طریق شماره پیگیری </strong>
                                    <hr />
                                </CardHeader>
                                <CardBody>
                                    <Col md="12" style={{ textAlign: "center" }}>

                                        <Col md="1"></Col>
                                        <Col md="10">
                                            <FormGroup>
                                            <span style={{font:'15px'}}> شماره رهگیری </span> 
                                                <Input
                                                    className={"Maxpading "}
                                                    style={{ color: "blue", fontSize: "160%", textAlign: "center" }}
                                                    defaultValue=""
                                                    placeholder="شماره رهگیری"
                                                    maxLength="40"
                                                    minLength="2"
                                                    type="number"
                                                    onChange={(e) => RefNumChangeHandel(e.target)}
                                                />
                                            </FormGroup>

                                            <FormGroup style={{ marginTop: "30px" }}>
                                                <Chapcha result={result1} refresh={captchaRefresh1} />
                                            </FormGroup>
                                            <FormGroup>
                                            <span style={{font:'15px'}}> کد امنیتی </span> 
                                                <Input
                                                    style={{ fontSize: "160%", textAlign: "center" }}
                                                    defaultValue=""
                                                    placeholder=" کد امنیتی"
                                                    type="text"
                                                    maxLength="6"
                                                    minLength="6"
                                                    number="true"
                                                    onChange={(e) => chapcha1HandelChange(e.target)}
                                                />
                                            </FormGroup>
               
                                        </Col>
                                        <Col md="1"></Col>
                                    </Col>

                                    <Col md="12" style={{ textAlign: "center", marginTop: "20px" }}>
                                    <button onClick={() => SubmitResNum()} type="button" className="button1">
                                      <span className="button__text"><i className="fa fa-search" style={{marginLeft:'5px'}}></i>استعلام</span>
                                                </button>
                               </Col>
                       
                                </CardBody>
                            </Card>
                        </Col>
       
                        <Col md="4" sm="12" xs="12">
                            <Card className="card-info">
                                <CardHeader style={{ textAlign: "center" }}>
                                    <strong>روش دوم: استعلام از طریق شناسه واریز  </strong>
                                    <hr />
                                </CardHeader>
                                <CardBody>
                                    <Col md="12" style={{ textAlign: "center" }}>
                                    <Col md="1"></Col>
                                     <Col md="10">
                                            <FormGroup>
                                                <span style={{font:'15px'}}> شناسه واریز </span> 
                                                <Input
                                                    className={"Maxpading " + VarizValidate}
                                                    style={{ color: "blue", fontSize: "160%", textAlign: "center" }}
                                                    defaultValue=""
                                                    placeholder="شناسه واریز  "
                                                    type="text"
                                                    maxLength="16"
                                                    minLength="8"
                                                    onChange={(event) => VarizChangeHandel(event.target)}
                                                />
                                            </FormGroup>

                                            <FormGroup style={{ marginTop: "30px" }}>
                                                <Chapcha result={result2} refresh={captchaRefresh2} />
                                            </FormGroup>

                                            <FormGroup>
                                            <span style={{font:'15px'}}> کد امنیتی </span> 
                                                <Input
                                                    style={{ fontSize: "160%", textAlign: "center" }}
                                                    defaultValue=""
                                                    placeholder=" کد امنیتی"
                                                    type="text"
                                                    maxLength="6"
                                                    minLength="6"
                                                    onChange={(e) => chapcha2HandelChange(e.target)}
                                                />
                                            </FormGroup>
                               
                                        </Col>
                                        <Col md="1"></Col>
                                    </Col>

                                    <Col md="12" style={{ textAlign: "center", marginTop: "20px" }}>
                                    <button onClick={() => SubmitVarizId()} type="button" className="button">
                                      <span className="button__text"><i className="fa fa-search" style={{marginLeft:'5px'}}></i>استعلام</span>
                                                </button>
                              </Col>
                            
                                </CardBody>
                            </Card>
                        </Col>
                        
<Col md="4" className="d-none d-md-block">
<div className="imginquiry" style={{ backgroundImage: `url(${background})` }}></div> 
</Col>
</Row>
                    </CardBody>
                </Card>
                {TipsPage.length > 0 ?
                    <Card className="card-info">
                        <CardHeader>
                            <strong>نکات</strong>
                            <hr />
                        </CardHeader>
                        <CardBody>

                            {TipsLoading ? <Loading /> :
                                <Row>
                                    <ul style={{ listStyle: "none" }}>
                                        {TipsPage.map(input =>
                                            <li>
                                                <i style={{ color: "blue" }} className="fa fa-circle"></i>&nbsp; {input.TipItemText} &nbsp;
                                                {input.LinkCaption != null && input.LinkCaption !== "" ?
                                                    <a className="btn btn-blue btn-sm" href={input.LinkAddress} target="_blank" rel="noopener noreferrer">{input.LinkCaption}</a> : ''
                                                }
                                            </li>
                                        )}
                                    </ul>
                                </Row>
                            }
                        </CardBody>
                    </Card> : ""}
            </div>
        </>
    );
}

export default Rules;
